import React, { useEffect, useMemo, useState } from 'react';
import CustomerRatingRanking from './CustomerRatingRanking';
import useTicket from 'src/hooks/api/useTicket';
import Ticket from 'src/interfaces/api/Ticket';
import { EmployeesProvider } from '../../../../hooks/useEmployees';

const CustomerRatingRankingContainer = ({}) => {
  const [startDateFilter, setStartDateFilter] = useState<string>();
  const [endDateFilter, setEndDateFilter] = useState<string>();
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const { search } = useTicket();

  const handleChangeDateFilter = (startDate?: string, endDate?: string) => {
    setStartDateFilter(startDate);
    setEndDateFilter(endDate);
  };

  useEffect(() => {
    search({ withRating: true, startDate: startDateFilter, endDate: endDateFilter }, 1).then((response) => {
      setTickets(response.items);
    });
  }, [startDateFilter, endDateFilter]);

  const employeesStats = useMemo(
    (): Record<string, { ticketCount: number; averageRating: number; totalRating: number }> =>
      tickets.reduce((stats, ticket) => {
        const employeeId = ticket.supportEmployeeId;

        if (!stats[employeeId]) {
          stats[employeeId] = {
            ticketCount: 0,
            totalRating: 0,
            averageRating: 0,
          };
        }

        stats[employeeId].totalRating += ticket.customerSatisfactionRating || 0;
        stats[employeeId].ticketCount++;
        stats[employeeId].averageRating = stats[employeeId].totalRating / stats[employeeId].ticketCount;

        return stats;
      }, {}),
    [tickets]
  );

  return (
    <EmployeesProvider>
      <CustomerRatingRanking
        onChangeDateFilter={handleChangeDateFilter}
        startDateFilter={startDateFilter}
        endDateFilter={endDateFilter}
        employeesStats={employeesStats}
      />
    </EmployeesProvider>
  );
};

export default CustomerRatingRankingContainer;
